import { Attention, Typography } from "@optimizely/axiom";
import { INVITATION_REVOKE_DAYS } from "../../../constants/constants";

export const SupportAutoRevokeNotice = ({ className }: { className?: string }) => {
    return (
        <Attention type="warning" className={className}>
            <Typography
                type="subhead"
                tag="div"
                className="push-double--bottom"
                data-testid="support-auto-revoke-notice"
            >
                Automatic access revocation
            </Typography>
            <Typography type="body" tag="p" className="push--bottom">
                Access granted via this form will be automatically revoked after{" "}
                <strong>{INVITATION_REVOKE_DAYS} days</strong>.
            </Typography>
            <Typography type="body" tag="p">
                If you need longer access to an organization, you will need to ask them to invite you to their
                organization as a regular user. Being added this way will grant you indefinite access until you are
                removed from that organization.
            </Typography>
        </Attention>
    );
};

SupportAutoRevokeNotice.displayName = "SupportAutoRevokeNotice";
